export var DIRECTION_UP = 'up';
export var DIRECTION_DOWN = 'down';
export var DIRECTION_LEFT = 'left';
export var DIRECTION_RIGHT = 'right';
export var DIRECTIONS = [DIRECTION_UP, DIRECTION_DOWN, DIRECTION_LEFT, DIRECTION_RIGHT];
export var DEFAULT_SLIDE_DIRECTION = DIRECTION_UP;
export var DEFAULT_SLIDE_DISTANCE = '26px';
export var DEFAULT_SLIDE_FADE = false;